<script lang="ts">
  import { onDestroy, untrack } from "svelte"
  import type { ContextSessionResponse } from "@kontextwerk/control-web-client"
  import type { createContextRootClient } from "@kontextwerk/control-web-frame/shared/logic/context-runtime"
  import OrderTypesSubview from "./OrderTypesSubview.svelte"
  import { createContextOrderTypes } from "./_logic/context"
  let {
    client,
    session,
    organizationId,
  }: {
    client: ReturnType<typeof createContextRootClient>
    session: ContextSessionResponse
    organizationId: string
  } = $props()
  const input = untrack(() => ({ client, session, organizationId }))
  const controller = createContextOrderTypes(input.client, input.session, input.organizationId)
  $effect(() => {
    if (
      client !== input.client ||
      session !== input.session ||
      organizationId !== input.organizationId
    )
      controller.dispose()
  })
  onDestroy(controller.dispose)
</script>

<section aria-label="Auftragstypen">
  {#if controller.binding}
    <OrderTypesSubview binding={controller.binding} />
  {:else}<p role="status">Zugang zu Auftragstypen nicht bestaetigt.</p>{/if}
</section>
